import { Maybe, NotFalsy } from './types'

export function isDefinedValue<T>(value: Maybe<T>): value is NotFalsy<T> {
	return !!value
}
